var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTrashIcon = function SvgTrashIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-stroke-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.696,
    height: 19.485,
    viewBox: "0 0 17.696 19.485"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon feather-trash-2",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 105825",
    d: "M.8 4.377h16.1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 105826",
    d: "M15.107 4.377V16.9a1.788 1.788 0 0 1-1.788 1.788H4.376A1.788 1.788 0 0 1 2.588 16.9V4.377m2.683 0V2.588A1.788 1.788 0 0 1 7.059.8h3.577a1.788 1.788 0 0 1 1.788 1.788v1.789"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 105827",
    d: "M7.06 8.848v5.365"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 105828",
    d: "M10.637 8.848v5.365"
  }))));
};
export default SvgTrashIcon;